import { render, staticRenderFns } from "./PortalSidebarWrapper.vue?vue&type=template&id=aa1ba442&scoped=true&"
import script from "./PortalSidebarWrapper.vue?vue&type=script&lang=js&"
export * from "./PortalSidebarWrapper.vue?vue&type=script&lang=js&"
import style0 from "./PortalSidebarWrapper.vue?vue&type=style&index=0&id=aa1ba442&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa1ba442",
  null
  
)

export default component.exports